import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileType',
  standalone: true
})
export class FileTypePipe implements PipeTransform {

  public static fileFormats: Record<string, string> = {
    '.jpeg': 'Image',
    '.jpg': 'Image',
    '.png': 'Image',
    '.mp4': 'Video',
    '.pdf': 'Document',
    '.html': 'App',
    default: 'Folder'
  };

  transform(format: string): string {
    const sanitizedFormat = format.toLowerCase();
    return FileTypePipe.fileFormats[sanitizedFormat] || FileTypePipe.fileFormats['default'];
  }

}
